import request from '../utils/request';

export async function getIncomes(params) {
  return request('/api/incomes', {
    method: 'GET',
    params: {
      page: params.current,
      page_size: params.pageSize,
      address: params.address,
      txid: params.txid,
      chain: params.chain,
      symbol: params.symbol,
      state: params.state,
      amount: params.amount,
      memo: params.memo
    }
  });
}
